import { render, staticRenderFns } from "./PrintInvoice.vue?vue&type=template&id=0887d8ce&scoped=true&"
import script from "./PrintInvoice.vue?vue&type=script&lang=js&"
export * from "./PrintInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887d8ce",
  null
  
)

export default component.exports